/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import _ from "lodash";
import Config from "data/config";
import { Logger } from "cms/utils/log/logger";

const removables = [
    "wasAlreadyDefault",
    "defaultImpl",
    "canUseDefaults",
    "isReused",
    // 'label',
    "usage",
    "version",
    "original",
];

export const cleanUnwantedProperties = (original, propertiesList) => {
    if (!original) {
        throw Error("original object was not defined");
    }
    const cleaner = structuredClone(original);
    if (!propertiesList) {
        propertiesList = removables;
    }
    for (const prop of propertiesList) {
        delete cleaner[prop];
    }
    return cleaner;
};
export const prepareUpdatedObject = (original, updates) => {
    let updatedObject = {
        ...structuredClone(original),
        ...structuredClone(updates),
    };
    updatedObject = cleanUnwantedProperties(updatedObject, removables);
    return updatedObject;
};
export const prepareChangeData = (original, modified) => {
    const _original = cleanUnwantedProperties(original, removables);
    const _modified = cleanUnwantedProperties(modified, removables);
    return { original: _original, modified: _modified };
};
export const checkDiffs = (original, modified, caller) => {
    const _original = structuredClone(original);
    const _modified = structuredClone(modified);
    // const isDirty = checkIsDirty(_original, _modified, caller)
    // Logger.debug(`checkDiffs [${caller}] - is dirty: `, isDirty)
    const diff = objectDiff(_original, _modified);
    const diffDetected = JSON.stringify(diff) !== "{}";
    if (diffDetected) {
        if (Config.Logging.enableSavePipelineLog) {
            Logger.debug(`     CHANGED     [${caller}] ${original.name} ${original.type} `);
            Logger.debug(`checkDiffs -> diff: ${JSON.stringify(diff)}`, diff);
            // console.debug(`%c      CHANGED     [${caller}] ${original.name} ${original.type} `, 'color: black; background-color: yellow')
            // console.debug('%c checkDiffs -> diff: ', 'color: #d41387', diff)
        }
        if (Config.Logging.enableSavePipelineLog) {
            Logger.debug(`checkDiffs -> diff created for: [${_original?.type}] [${original?.guid}]`);
            Logger.debug(`checkDiffs -> diff: ${JSON.stringify(diff)}`, { diff });
            Logger.debug("original", { _original });
            Logger.debug("modified", { _modified } );
            // console.debug(`%c checkDiffs -> diff created for: [${_original.type}]`, 'color: #d41387', _original.guid)
            // console.debug('%c checkDiffs -> diff: ', 'color: #d41387', diff)
            // console.debug('%c original', 'color: #d41387', _original)
            // console.debug('%c modified', 'color: #d41387', _modified)
        }
    } else {
        if (Config.Logging.enableSavePipelineLog) {
            Logger.debug(`    no change     [${caller}] ${original.name} ${original.type} `);
            Logger.debug(`checkDiffs -> diff created for: [${_original.type}] - [${_original.guid}]`);
            Logger.debug(`checkDiffs -> diff: ${JSON.stringify(diff)}`, { diff });
            Logger.debug("original", { _original });
            Logger.debug("modified", { _modified });
            // console.debug(`%c     no change     [${caller}] ${original.name} ${original.type} `, 'color: black; background-color: #2a9ac9')
            // console.debug(`%c checkDiffs -> diff created for: [${_original.type}] - [${_original.guid}]`, 'color: #2a9ac9')
            // console.debug('%c checkDiffs -> diff: ', 'color: #2a9ac9', diff)
            // console.debug('%c original', 'color: #2a9ac9', _original)
            // console.debug('%c modified', 'color: #2a9ac9', _modified)
        } else {
            if (Config.Logging.enableSavePipelineLog) {
                Logger.debug(`     no change     [${caller}] ${original.name} ${original.type} `);
            }
        }
    }
    // Logger.flush()
    return diffDetected;
};
export const getDiff = (original, modified) => {
    return objectDiff(original, modified);
};
// export const checkIsDirty = (original, modified) => {
//     // const isDirty = JSON.stringify(original) !== JSON.stringify(modified)
//     const _original = structuredClone(original)
//     const _modified = structuredClone(modified)
//     const diff = objectDiff(_original, _modified)
//     const isDirty = JSON.stringify(diff) !== '{}'
//     // if (isDirty) {
//     //     Logger.debug(`%c ${caller} is dirty: `, 'color: #ff45b5', isDirty)
//     //     Logger.flush()
//     // }
//     return isDirty
// }

export const objectDiff = function (original, modified) {
    function changes (modified, original) {
        return _.transform(modified, function (result, value, key) {
            if (!_.isEqual(value, original[key])) {
                result[key] = _.isObject(value) && _.isObject(original[key]) ? changes(value, original[key]) : value;
            }
        });
    }
    return changes(modified, original);
};
